<div class="icons-template">
  <a class="nav-item nav-link " style="font-size:0.8rem;" routerLink="/dossiers-compta-encours">
    <img src="../../../assets/bar-icons/compta-encours.svg" *ngIf="showEncours || showCm" >
  </a>
  <a class="nav-item nav-link " style="font-size:0.8rem;" routerLink="/dossiers-compta-encours">
    <img src="../../../assets/bar-icons/compta-encours-active.svg" *ngIf="!showEncours && !showCm"
      >
  </a>
  <a class="nav-item nav-link " style="font-size:0.8rem;" routerLink="/compta-cm-table">
    <img src="../../../assets/bar-icons/cm.svg">
  </a>

  <a class="nav-item nav-link " style="font-size:0.8rem;" routerLink="/compta-primes-table">
    <img src="../../../assets/bar-icons/primes.svg">
  </a>

  <a class="nav-item nav-link " style="font-size:0.8rem;" routerLink="/compta-leads">
    <img src="../../../assets/bar-icons/audit.svg">
  </a>
</div>

<div class="compta-dashboard">
  <h2 class="my-3">
    Pégase vous souhaite la bienvenue,
    <strong style="color: var(--tertiarycrm)">{{ user.username }}</strong>
  </h2>

  <div class="row">
    <div class="col-8 card-top d-flex">
      <div class="left-component col-6">
        <div id="time"></div>

        <h1>{{ realtimeDate }}</h1>
        <p class="today">{{ date | date : "EEEE d MMMM" }}</p>
      </div>

      <div class="right-component col-6">
        <ul class="numbers">
          <li class="mt-4">
            <h5 class="section-header">Néros</h5>
          </li>
          <li class="mt-4"><u>LERIS Maxime </u>06 50 61 17 16</li>
          <li class="mt-4"><u>NORIEGA Tony </u>06 24 97 27 53</li>
          <li class="mt-4"><u>ABBES Zouhair </u>07 51 23 68 96</li>
          <li class="mt-4"><u>KENN KICHENIN </u>07 66 69 01 66</li>
          <li class="mt-4"><u>Arthur CHARIOUX </u>06 11 42 15 26</li>
          <li class="mt-4">
            <h5 class="section-header">Sparthios</h5>
          </li>
          <li class="mt-4"><u>MAGUEROT Loïc </u>06 45 15 17 58</li>

          <li class="mt-4">
            <h5 class="section-header">Inti</h5>
          </li>
          <li class="mt-4"><u>LAKHRIF Smail </u>07 87 17 08 45</li>

          <li class="mt-4">
            <h5 class="section-header">Amon</h5>
          </li>
          <li class="mt-4"><u>NORIEGA Olivier </u>06 27 83 16 75</li>
          <li class="mt-4"><u>LAMAURY Lucas </u>06 46 55 51 76</li>
          <li class="mt-4"><u>MENARD Axel </u>06 16 58 28 94</li>
        </ul>
      </div>
    </div>

    <div class="col-4 notifs">
      <h4 class="p-4">Notifications</h4>
      <div *ngIf="loading" class="snippet pl-5" data-title=".dot-typing">
        <div class="stage">
          <div class="dot-typing"></div>
        </div>
      </div>
      <div class="pl-4" *ngFor="let info of infosUnread">
        <div *ngIf="info.reason && info.reason === 'commentaire'">
          <h5 class="mt-3">
            {{ info.created_by.username }}
            <mat-icon (click)="deleteInfo(info._id)" class="trash">close</mat-icon>
          </h5>
          <p>
            vous a mentionné sur un commentaire le
            {{ info.created_at | date : "medium" }} sur l'affaire de
            <a (click)="goToCase(info.caseId._id, info, info._id)" style="text-decoration: underline; color: orangered">{{
              info.customerId.name }}</a>
          </p>
        </div>
        <div *ngIf="info.reason && info.reason === 'like'">
          <h5 class="mt-3">
            {{ info.created_by.username }}
            <mat-icon (click)="deleteInfo(info._id)" class="trash">close</mat-icon>
          </h5>
          <p>
            {{ info.comment }} votre commentaire le
            {{ info.created_at | date : "medium" }} sur l'affaire de
            <a (click)="goToCase(info.caseId._id, info, info._id)" style="text-decoration: underline; color: orangered">{{
              info.customerId.name }}</a>
          </p>
        </div>
        <div *ngIf="info.reason && info.reason === 'chantier'">
          <h5 class="mt-3">
            {{ info.created_by.username
            }}<mat-icon (click)="deleteInfo(info._id)" class="trash">close</mat-icon>
          </h5>
          <p>
            a changé le {{ info.comment }} sur l'affaire
            <a (click)="goToCase(info.caseId._id, info, info._id)" style="text-decoration: underline; color: orangered">{{
              info.customerId.name }}</a>
          </p>
        </div>
      </div>

    </div>
  </div>

  <div class="row">
    <div class="col-8 pl-0 d-flex">

      <div class="col-6 pl-0" *ngIf="
          this.sRoles.user.id != '5ff22939e4e34600046c014f' ||
          this.sRoles.user.id != '5ff22aa6a0f2570004f151d1' ||
          this.sRoles.user.id != '61f7e5e70d8ab20004bc072e'
        ">
        <div class="left-content card col-12">
          <h4 class="p-4">Primes</h4>
          <div class="text-center">
            <a [routerLink]="['/compta-primes-table']">Accéder au tableau des primes</a>
          </div>

        </div>
      </div>

      <div class="card col-6 ml-3" *ngIf="
          this.sRoles.user.id != '5ff22939e4e34600046c014f' &&
          this.sRoles.user.id != '5ff22aa6a0f2570004f151d1' &&
          this.sRoles.user.id != '61f7e5e70d8ab20004bc072e'
        ">
        <h4 class="p-4">Suivi des dossiers</h4>
        <div class="p-4 text-center">
          <a [routerLink]="['/dossiers-compta-encours']">Accéder à mes dossiers</a> <br>
          <a [routerLink]="['/compta-leads']">Accéder aux Leads</a> <br>
          <a [routerLink]="['/table-gdd']">Suivi GDD</a>

        </div>
      </div>
    </div>
  </div>
</div>
